import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { BackdropLoader, SimpleModal } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import useStyles from './styles';
import { observer } from 'mobx-react-lite';
import { ProviderSetupModalContent } from './ProviderSetupModalContent';
import { useStore } from 'src/stores';
import { ALLOCATION_METHOD } from 'src/constants/utilities';
import { AssociatedVendor } from 'src/components/shared/AssociatedVendor';
export const ProviderSetupModal = observer(_ref => {
  var _store$addNewProperty, _store$addNewProperty2, _store$addNewProperty3;
  let utilityProviderId = _ref.utilityProviderId,
    utilityProviderName = _ref.utilityProviderName,
    trigger = _ref.trigger,
    externalIsOpen = _ref.externalIsOpen,
    externalHandleOpen = _ref.externalHandleOpen,
    externalHandleClose = _ref.externalHandleClose,
    handleConfigChange = _ref.handleConfigChange,
    onSave = _ref.onSave,
    isNew = _ref.isNew,
    isEdit = _ref.isEdit,
    isDetailsPage = _ref.isDetailsPage,
    propertyId = _ref.propertyId;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useReducer = useReducer(x => x + 1, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  const getVendorsByUtilityProviderIdAsync = async () => {
    await store.vendors.getVendorsByUtilityProviderIdAsync.run({
      utilityProviderId: utilityProviderId
    }).then(() => {
      forceUpdate();
    });
  };
  useEffect(() => {
    if (externalIsOpen && store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled) getVendorsByUtilityProviderIdAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [externalIsOpen]);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    key: isNew ? 'PROVIDER_SETUP_MODAL' : "PROVIDER_SETUP_MODAL_".concat(utilityProviderId),
    id: isNew ? 'PROVIDER_SETUP_MODAL_ID' : "PROVIDER_SETUP_MODAL_".concat(utilityProviderId),
    trigger: trigger,
    title: t('add_new_property_flow.provider_setup'),
    subTitle: utilityProviderName,
    rightButton: /*#__PURE__*/React.createElement(Button, {
      variant: "contained",
      disabled: ((_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.utilities.filter(i => i.isEnabled && (ALLOCATION_METHOD.BySquareFootage === i.allocationMethod || ALLOCATION_METHOD.By50Occupancy50SquareFootage === i.allocationMethod)).length) !== 0 && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0,
      onClick: () => onSave({
        goNext: false
      }),
      'custom-attribute': '214-ProviderSetupModal'
    }, t('add_new_property_flow.save_and_close_ps')),
    noLeftButton: true,
    variant: "staticHeight",
    isOpen: externalIsOpen,
    handleOpen: externalHandleOpen,
    handleClose: () => {
      store.vendors.changeTempDataVendor(null);
      store.vendors.changeTempDataProperty(null);
      externalHandleClose();
    }
  }, store.company.companyFeatureStore.isAppfolio && store.account.featureFlagsStore.getIsPushUtilityBillAppFolioEnabled && /*#__PURE__*/React.createElement(AssociatedVendor, {
    utilityProviderId: utilityProviderId,
    utilityProviderName: utilityProviderName
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.please_setup_utilities')), /*#__PURE__*/React.createElement("div", {
    className: classes.xssSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.utilities_have_been_configured'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, (_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) !== null && _store$addNewProperty2 !== void 0 && _store$addNewProperty2.utilities && (_store$addNewProperty3 = store.addNewProperty.utilitiesSetupV2.getUtilityConfigurator) !== null && _store$addNewProperty3 !== void 0 && _store$addNewProperty3.utilities.length && !store.utilityProviders.getUtilityProvidersListDataAsync.inProgress && !store.utilityProviders.getUtilityInfoAsync.inProgress ? /*#__PURE__*/React.createElement(ProviderSetupModalContent, {
    key: isNew ? 'PROVIDER_SETUP_MODAL_CONTENT_KEY' : "PROVIDER_SETUP_MODAL_CONTENT_KEY_".concat(utilityProviderId),
    id: isNew ? 'PROVIDER_SETUP_MODAL_CONTENT_ID' : "PROVIDER_SETUP_MODAL_CONTENT__ID_".concat(utilityProviderId),
    handleConfigChange: handleConfigChange,
    isNew: isNew,
    isEdit: isEdit,
    isDetailsPage: isDetailsPage,
    hideNotEnabled: false,
    propertyId: propertyId,
    hideSaved: false
  }) : /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: true
  })));
});